import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Edit,
  TextInput,
  SimpleForm,
  TopToolbar,
  ListButton,
  ShowButton,
  useNotify,
  useRefresh,
  BooleanInput,
  NumberInput,
  DateInput,
} from "react-admin";

const AntibioticsActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

export const AntibioticsEdit = (props) => {
  const today = new Date();

  const notify = useNotify();
  const refresh = useRefresh();
  // const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Changes saved`);
    // redirect("/posts");
    refresh();
  };
  return (
    <Edit
      title="Edit Antibiotics"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<AntibioticsActions />}
      {...props}
    >
      <SimpleForm defaultValue={{ updated_at: today }}>
        <TextInput source="name" />
        <BooleanInput source="is_discrete" />
        <TextInput locales="es-UY" source="start_date" />
        <DateInput locales="es-UY" source="end_date" />
        <TextInput source="mic_susceptible_op" />
        <NumberInput source="mic_susceptible" />
        <TextInput source="mic_intermediate_op" />
        <NumberInput source="mic_intermediate" />
        <TextInput source="mic_resistant_breakpoint_op" />
        <NumberInput source="mic_resistant_breakpoint" />
        <TextInput source="notes" />
      </SimpleForm>
    </Edit>
  );
};
